module.exports = __webpack_public_path__ + "img/22.30a3113.webp";